import { useEffect, useState } from 'react'
import { useProductVariantApi } from 'src/api/db/apiProductVariant'
import { Column } from 'src/shared/components/Semantic/all'
import { ScrollArea } from 'src/shared/components/ui/scroll-area'
import { ColorsTabProps } from './types'
import { Variant } from './components/Variant'
import { SCROLL_HEIGHTS } from './consts'

export const ColorsTab = ({
  productToUpdate,
  onHasChangesChange,
}: ColorsTabProps) => {
  const { productVariants } = useProductVariantApi({
    product_id: productToUpdate,
  })

  const variants = productVariants?.data

  const [colorItemChanges, setColorItemChanges] = useState<
    Record<number, boolean>
  >({})
  const [newColorChanges, setNewColorChanges] = useState<
    Record<number, boolean>
  >({})

  const handleColorItemChange = (id: number, hasChanges: boolean) => {
    setColorItemChanges((prev) => ({
      ...prev,
      [id]: hasChanges,
    }))
  }

  const handleNewColorChange = (variantId: number, hasChanges: boolean) => {
    setNewColorChanges((prev) => ({
      ...prev,
      [variantId]: hasChanges,
    }))
  }

  useEffect(() => {
    if (!onHasChangesChange || !variants) return

    const hasAnyColorItemChanges = Object.values(colorItemChanges).some(
      (hasChanges) => hasChanges
    )
    const hasAnyNewColorChanges = Object.values(newColorChanges).some(
      (hasChanges) => hasChanges
    )

    onHasChangesChange(hasAnyColorItemChanges || hasAnyNewColorChanges)
  }, [colorItemChanges, newColorChanges, onHasChangesChange, variants])

  return (
    <ScrollArea className={SCROLL_HEIGHTS.MAIN_CONTAINER}>
      <Column className="gap-6 p-1">
        {variants && variants.length > 0 ? (
          variants.map((variant: any) => (
            <Variant
              key={variant.id}
              variant={variant}
              onNewColorChange={handleNewColorChange}
              onColorItemChange={handleColorItemChange}
            />
          ))
        ) : (
          <div className="flex items-center justify-center h-full text-muted-foreground">
            <p className="text-sm">No variants found</p>
          </div>
        )}
      </Column>
    </ScrollArea>
  )
}
